<template>
  <div>
    <top-header :type="6" placeholder="积分明细" fontSize="0.32rem" />
    <div class="top m_flex_box flex_vc flex_jz">
      <div class="m_flex_box flex_vc">
        <img src="@/assets/img/score.png" alt="">
        <p>我的积分</p>
      </div>
      <h3>{{score}}</h3>
    </div>
    <div class="pad_top"></div>
    <div class="list">
      <van-pull-refresh v-model="isLoading" @refresh="onRefresh">
        <van-list
          v-model="loading"
          :finished="finished"
          finished-text="没有更多了"
          @load="onLoad"
        >
          <div class="no_data" v-if="!list.length">
            <img src="@/assets/img/nodata.png" alt="">
          </div>
          <div class="inner m_flex_box flex_vc flex_jz" v-for="(item, index) in list" :key="index">
            <div>
              <h4 class="line_comp1">{{item.msg}}</h4>
              <p>{{item.createDate | formatTime('yyyy-MM-dd hh:mm:ss')}}</p>
            </div>
            <h5>{{item.alterScore}}</h5>
          </div>
        </van-list>
      </van-pull-refresh>
    </div>
  </div>
</template>

<script>
import qs from "qs";
import topHeader from "@/components/header";
export default {
  data() {
    return {
      isLoading: false,
      loading: false,
      finished: false,
      list: [],
      listPage: 1,
      timer: null,
      score: 0,
    };
  },
  components: {
    topHeader
  },

  filters: {
    formatTime: function (dates, fmt) {
      var date = new Date(dates);
      if (/(y+)/.test(fmt)) {
        fmt = fmt.replace(RegExp.$1, (date.getFullYear() + '').substr(4 - RegExp.$1.length));
      }
      var o = {
        'M+': date.getMonth() + 1,
        'd+': date.getDate(),
        'h+': date.getHours(),
        'm+': date.getMinutes(),
        's+': date.getSeconds()
      };
      for (var k in o) {
        if (new RegExp('(' + k + ')').test(fmt)) {
          var str = o[k] + '';
          fmt = fmt.replace(RegExp.$1, (RegExp.$1.length === 1) ? str : ('00' + str).substr(str.length));
        }
      }
      return fmt;
    }
  },
  mounted() {},
  methods: {
    onRefresh() {
      this.loading = false;
      this.finished = false;
      this.$set(this, 'listPage', 1)
      this.$set(this, 'list', [])
      this.onLoad(1);
    },

    onLoad(type) {
      if (!this.timer) {
        this.timer = setTimeout(() => {
          this.timer = null;
        }, 50)
        this.$http({
          url: 'cms/onlineUserScore/reg/getScorePageByOffset.do',
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          data: {
            pageSize: 10,
            offset: (this.listPage - 1) * 10,
          }
        }).then(res => {
          if (type) {
            this.isLoading = false;
          }
          if (res.success) {
            this.score = res.attributes.score ? res.attributes.score : 0;
            this.list = this.list.concat(res.obj.rows)
            this.loading = false;
            this.listPage += 1;
          } else {
            this.finished = true;
          }
        })
      }
    },

  },
};
</script>
<style lang="less" scoped>
.pad_top{
  padding-top: 2rem;
}
.top{
  position: fixed;
  top: 0.9rem;
  left: 0;
  right: 0;
  padding: 0.52rem 0.23rem 0.42rem;
  border-bottom: 0.16rem solid #f5f5f5;
  img{
    width: 0.9rem;
  }
  p{
    font-size: 0.3rem;
    color: #7973F1;
    margin-left: 0.2rem;
  }
  h3{
    font-size: 0.42rem;
    color: #303030;
  }
}
.list{
  padding: 0 0.23rem;
}
.inner{
  padding: 0.3rem 0;
  border-bottom: 1px solid #f5f5f5;
  h4{
    font-size: 0.26rem;
    margin-bottom: 0.14rem;
    max-width: 5rem;
  }
  p{
    font-size: 0.26rem;
    color: #B0B0B0;
  }
  h5{
    font-size: 0.26rem;
    font-weight: 800;
  }
}
</style>